export const CREATE_SUPPLIER = 'CREATE_SUPPLIER';
export const EDIT_SUPPLIER = 'EDIT_SUPPLIER';
export const DELETE_SUPPLIER = 'DELETE_SUPPLIER';
export const LIST_SUPPLIERS = 'LIST_SUPPLIERS';
export const SET_LOADING = 'SET_LOADING';
export const UPDATE_PRODUCTS_AFTER_DELETE_SUPPLIER = 'UPDATE_PRODUCTS_AFTER_DELETE_SUPPLIER';